import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import IntercomMixin from '@/components/helpers/intercom-mixin';
import { switchDesktopMobileView } from '@/routes/hooks/desktop-view-forced';
import config from '@/config';
  


@Component
export default class NavbarSupportMixin extends mixins(IntercomMixin)  {
  @Prop({ default: [] })
  hiddenElements: string[];

  @Prop({ default: false }) 
  hasCloseIntercom: boolean;

  handleOpenLiveSupport() {
    this.openLiveSupport();
  }

  handleCloseLiveSupport() {
    this.closeLiveSupport();
  }

  quickStart() {
    this.$store.commit('quickStart', !this.$store.state.tutorial.quickStart);
  }

  toggleMobileDesktopViewForced() {
    this.$store.commit('mobileDesktopViewForced', !this.$store.state.mobile.desktopViewForced);
    switchDesktopMobileView(this.$store.state.mobile.desktopViewForced);
  }

  get helpCenterLink() {
    return `https://docs.bemob.com/${this.$i18n.locale}/home`
  }

  get blogLink() {
    return config.blogLink;
  }

  onTemporaryPassword() {
    this.$emit('temporary-password');
  }

  get actions() {
    return {
      openLiveSupport: {
        key: 'openLiveSupport',
        title: this.t('Open live chat'),
        iconAppend: 'fas fa-question',
        showCondition: !this.hiddenElements.includes('openLiveSupport') && !this.isIntercomOpen,
        click: () => this.handleOpenLiveSupport()
      },
      closeLiveSupport: {
        key: 'closeLiveSupport',
        title: this.t('Close live chat'),
        iconAppend: 'fas fa-times',
        showCondition: this.hasCloseIntercom && this.isIntercomOpen,
        click: () => this.handleCloseLiveSupport()
      },
      helpCenterLink: {
        key: 'helpCenterLink',
        title: this.t('Help center'),
        iconAppend: 'fas fa-book',
        href: this.helpCenterLink,
        target: '_blank'
      },
      quickStart: {
        key: 'quickStart',
        title: this.t('Quick start'),
        iconAppend: 'fa fa-life-ring',
        click: () => this.quickStart(),
      },
      blog: {
        key: 'blog',
        title: this.t('Blog'),
        iconAppend: 'far fa-newspaper',
        href: this.blogLink,
        target: '_blank'
      },
      createTemporaryPassword: {
        key: 'createTemporaryPassword',
        title: this.t('Create temporary password'),
        iconAppend: 'fas fa-ellipsis-h',
        click: () => this.onTemporaryPassword()
      },
      forceDesktopView: {
        key: 'forceDesktopView',
        title: this.t('Desktop view'),
        iconAppend: 'fa fa-desktop',
        click: () => this.toggleMobileDesktopViewForced(),
        showCondition: this.$store.state.mobile.desktopViewForced === false
      },
      forceMobileView: {
        key: 'forceMobileView',
        title: this.t('Mobile view'),
        iconAppend: 'fa fa-mobile',
        click: () => this.toggleMobileDesktopViewForced(),
        showCondition: this.$store.state.mobile.desktopViewForced === true
      }
    }
  }
}
